import type { ReactNode } from 'react'

import { Box, Button, Icon, Text, Link } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { Sync } from 'modules/payroll_integrations_datev_lauds/lib/IncidenceSync/store'

interface Props {
  onSync: () => void
  syncing: boolean
  isLeaveIncidence?: boolean
  submitButton: string
  sync: Sync
}

const Blocked = ({ onSync, syncing, submitButton, sync, isLeaveIncidence }: Props) => {
  const isDuplicateAbsence =
    isLeaveIncidence &&
    sync.error_code &&
    ['#DXLO02413', 'Absence.Overlap', '#LN6713', '#LN24947', '#LN24927'].includes(sync.error_code)

  const Content = ({ title, description }: { title: string; description: ReactNode }) => {
    return (
      <>
        <Box gap="s4" flexDirection="row">
          <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />
          <Text.Header2>{title}</Text.Header2>
        </Box>
        <Box>{description}</Box>
      </>
    )
  }

  const getContent = () => {
    switch (sync.error_code) {
      case '#DXLO02413':
      case '#LN5420':
      case 'Absence.Overlap':
      case '#LN6713':
      case '#LN24947':
      case '#LN24927':
        return (
          <Content
            title={
              isLeaveIncidence
                ? i18n.t('payroll_integrations.incidences.datev_lauds.absences.blocked.title')
                : i18n.t(
                    'payroll_integrations.incidences.datev_lauds.hiring.error.employee_code_title'
                  )
            }
            description={
              isLeaveIncidence
                ? i18n.t(
                    'payroll_integrations.incidences.datev_lauds.absences.overlap_dates.message'
                  )
                : i18n.t(
                    'payroll_integrations.incidences.datev_lauds.hiring.error.employee_code_message'
                  )
            }
          />
        )
      case '#DCO02404':
      case '#DCO02402':
        return (
          <Content
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.consultant_client_code_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.consultant_client_code_message'
            )}
          />
        )
      case '#DCO02401':
      case '#DCO02440':
        return (
          <Content
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.tax_advisor_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.tax_advisor_message'
            )}
          />
        )
      case '403':
        return (
          <Content
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.salary_mismatch_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.salary_mismatch_description'
            )}
          />
        )
      case '404':
        return (
          <Content
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.salary_missing_title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.salary_missing_description'
            )}
          />
        )
      case 'EmploymentPeriod.Overlap':
      case 'EmploymentPeriod.UniqueInMonth':
        return (
          <Content
            title={i18n.t(
              'payroll_integrations.incidences.datev_lauds.termination.error.starts_on_mismatch.title'
            )}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.termination.error.starts_on_mismatch.message'
            )}
          />
        )
      case '#DCO02442':
        return (
          <Content
            title={i18n.t('payroll_integrations.incidences.datev_lauds.datev_service_error.title')}
            description={i18n.tView(
              'payroll_integrations.incidences.datev_lauds.datev_service_error.description',
              {
                link: (
                  <Link.Href
                    href="https://apps.datev.de/rvo-administration/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18n.t('payroll_integrations.incidences.datev_lauds.datev_service_error.link')}
                  </Link.Href>
                ),
              }
            )}
          />
        )
      default:
        return (
          <Content
            title={i18n.t('payroll_integrations.incidences.datev_lauds.hiring.error.title')}
            description={i18n.t(
              'payroll_integrations.incidences.datev_lauds.hiring.error.generic_error_message'
            )}
          />
        )
    }
  }

  return (
    <>
      {getContent()}
      {!isDuplicateAbsence && (
        <Button onClick={onSync} disabled={syncing} type="secondary">
          {submitButton}
        </Button>
      )}
    </>
  )
}

export default Blocked
